import type { DocMigration } from "../docMigration";

const migration: DocMigration = {
  id: "20260416_prune_unreferenced_groups",
  description: "Remove orphan groups that have no entityGroups references (created by a room duplication bug)",
  apply(json: any) {
    const groups: Record<string, any> | undefined = json.groups;
    const entityGroups: Record<string, string> | undefined = json.entityGroups;
    const entityRefs: Record<string, any> | undefined = json.entityRefs;

    if (!groups || !entityGroups) {
      return json;
    }

    const referencedGroupIds = new Set<string>(Object.values(entityGroups));

    for (const groupId of Object.keys(groups)) {
      const group = groups[groupId];

      if (group?.isBuiltIn) {
        continue;
      }

      if (entityRefs?.[groupId]) {
        continue;
      }

      if (!referencedGroupIds.has(groupId)) {
        delete groups[groupId];
      }
    }

    return json;
  },
};

export default migration;
